import { Select } from "antd"
import { useField } from "formik";
import { useSelector } from 'react-redux';
import Flex from '@react-css/flex'
import './field.css'

export const Dropdown = (props) => {

    const {
        hasErrorInitial,
        disabled,
        isLoading: propsIsLoading,
        isLoadingOptions,
        formik: _formik,
        onChange: parentOnChange,
        style,
        ...selectProps
    } = props

    const [field, meta, helpers] = useField(props.name);
    const selectedOption = props?.options?.find(
        (option) => String(option?.value ?? '') === String(meta?.value ?? '')
    )?.value;
    const { isGlobalLoading, isAccountLoading, isRefreshAccount, hasError: anyError } = useSelector(state => state.dashboard);
    const isLoading = isGlobalLoading || propsIsLoading || isLoadingOptions || isAccountLoading || isRefreshAccount;
    let status = hasErrorInitial ? 'error' : false;

    if (anyError && meta.error && !props.disabled) {
        status = 'error'
    }

    const handleChange = (value) => {
        helpers.setValue(value ?? '');
        parentOnChange?.(value);
    };

    return (
        <>
            <Flex column>
                <Select
                    {...selectProps}
                    name={field.name}
                    onBlur={field.onBlur}
                    style={{ maxWidth: 320, ...style }}
                    allowClear
                    showSearch
                    value={selectedOption}
                    loading={isLoading}
                    status={status}
                    disabled={disabled || isLoading}
                    placeholder={selectProps.placeholder ?? "Select an option"}
                    onChange={handleChange}
                    optionFilterProp="label"
                    filterOption={(input, option) =>
                        String(option?.label ?? '').toLowerCase().includes(String(input ?? '').toLowerCase())
                    }
                    autoComplete="none"
                />
                {status &&
                    <Flex>
                        <p className="required-label">
                            Required
                        </p>
                    </Flex>
                }
            </Flex>
        </>
    )
}
